import { render, staticRenderFns } from "./SectionGridManagement.vue?vue&type=template&id=22cd574f&scoped=true&"
import script from "./SectionGridManagement.vue?vue&type=script&lang=js&"
export * from "./SectionGridManagement.vue?vue&type=script&lang=js&"
import style0 from "./SectionGridManagement.vue?vue&type=style&index=0&id=22cd574f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd574f",
  null
  
)

export default component.exports